import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=645291b6&scoped=true"
import script from "./Renderer.vue?vue&type=script&lang=js"
export * from "./Renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645291b6",
  null
  
)

export default component.exports